import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-090e5cf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "q-pa-sm ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "app__color--label q-ma-md"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = {
  key: 0,
  class: "app__label--medium app__color--semigray",
  style: {"padding-top":"5rem"}
}
const _hoisted_6 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_7 = { style: {"color":"black","font-weight":"bold"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  class: "produs_img",
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_11 = { style: {"display":"flex","align-items":"center","flex-direction":"column","gap":"2px"} }
const _hoisted_12 = { class: "absolute-full flex flex-center bg-negative text-white" }
const _hoisted_13 = { class: "produs_detalii" }
const _hoisted_14 = { class: "app__property--medium" }
const _hoisted_15 = {
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { key: 6 }
const _hoisted_23 = {
  key: 0,
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 1,
  class: "app__color--semigray",
  style: {"font-weight":"lighter","font-style":"italic"}
}
const _hoisted_27 = { class: "app__property--medium" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "shopping_cart__container--btns" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { style: {"color":"black","font-weight":"bold"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_40 = { style: {"color":"black","font-weight":"bold","margin-bottom":"8px"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = {
  key: 3,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_43 = {
  key: 4,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 100px)","top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_NomEditAdresaLivrare = _resolveComponent("NomEditAdresaLivrare")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$q.platform.is.desktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_q_icon, {
                  name: "shopping_cart",
                  style: {"font-size":"2rem","top":"-3px"},
                  color: "primary"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.my_basket')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.basket.length ==0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('message.no_basket')), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.$t('message.items_in_basket')) + ": " + _toDisplayString(_ctx.basket.length), 1),
              _hoisted_8
            ]),
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basket, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.appid,
                class: "produs_div"
              }, [
                (item.appid==_ctx.appidToBeRemovedFromBasket)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      indeterminate: "",
                      color: "secondary",
                      style: {"position":"absolute"}
                    }))
                  : _createCommentVNode("", true),
                (item.appid==_ctx.appidToBeTogglesWithFavorites)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 1,
                      indeterminate: "",
                      color: "secondary",
                      style: {"position":"absolute"}
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "arrow_drop_up",
                      onClick: ($event: any) => (_ctx.moveUP(index))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(index+1), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_btn, {
                      flat: "",
                      icon: "arrow_drop_down",
                      onClick: ($event: any) => (_ctx.moveDown(index))
                    }, null, 8, ["onClick"])
                  ]),
                  _createVNode(_component_q_img, {
                    transition: "fade",
                    src: _ctx.urlToJPG+'/'+_ctx.getFirstCategory(item.categoryPid),
                    ratio: "1",
                    fit: "scale-down",
                    "spinner-color": "light-blue",
                    class: "rounded-borders shopping_cart--img shadow-1"
                  }, {
                    error: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('message.cannot_load_image')), 1)
                    ]),
                    _: 2
                  }, 1032, ["src"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$i18n.locale === 'ro' ? item.productNameRO : _ctx.$i18n.locale === 'en' ? item.productNameEN : item.productNameBG), 1),
                  _createElementVNode("span", _hoisted_15, [
                    (item.l)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('message.length')) + " " + _toDisplayString(item.l) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.w)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('message.width')) + " " + _toDisplayString(item.w) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.t)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('message.thickness')) + " " + _toDisplayString(item.t) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.d)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('message.diameter')) + " " + _toDisplayString(item.d) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.h)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('message.height')) + " " + _toDisplayString(item.h) + " mm ", 1))
                      : _createCommentVNode("", true),
                    (item.a)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('message.aliaj')) + " " + _toDisplayString(item.a), 1))
                      : _createCommentVNode("", true),
                    (item.k)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('message.type')) + " " + _toDisplayString(_ctx.typeLabel(item.k)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (item.dorescDebitare)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        _createTextVNode(_toDisplayString(item.qBuc) + " " + _toDisplayString(_ctx.$t('message.cutted_nr')) + " ", 1),
                        (item.cuttingLength)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('message.length')) + " " + _toDisplayString(item.cuttingLength) + " mm ", 1))
                          : _createCommentVNode("", true),
                        (item.cuttingWidth)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('message.width')) + " " + _toDisplayString(item.cuttingWidth) + " mm ", 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (item.observatii)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('message.remarks')) + ": " + _toDisplayString(item.observatii), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.showQtyUm1(item))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.qUm1) + " " + _toDisplayString(_ctx.$umLabel(item.um1)), 1))
                    : _createCommentVNode("", true),
                  (item.um2 && item.um2.length>0 && (item.tip_um == 'um12' || item.tip_um == 'um2'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(item.qUm2) + " " + _toDisplayString(_ctx.$umLabel(item.um2)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_q_btn, {
                    color: "red",
                    flat: "",
                    onClick: ($event: any) => (_ctx.removeArticleFromShoppingCart(item)),
                    "no-caps": "",
                    "no-wrap": "",
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        left: "",
                        name: "delete_forever"
                      }),
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.delete_basket')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    flat: "",
                    color: "blue",
                    "no-caps": "",
                    "no-wrap": "",
                    dense: "",
                    onClick: ($event: any) => (_ctx.toggleArticleInFavorites(item))
                  }, {
                    default: _withCtx(() => [
                      (item.isInFavorite)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            left: "",
                            name: "favorite",
                            color: "primary"
                          }))
                        : (_openBlock(), _createBlock(_component_q_icon, {
                            key: 1,
                            left: "",
                            name: "favorite_border",
                            color: "blue"
                          })),
                      _createVNode(_component_q_tooltip, {
                        anchor: "top middle",
                        self: "bottom middle",
                        offset: [10, 10],
                        "transition-show": "scale",
                        "transition-hide": "scale"
                      }, {
                        default: _withCtx(() => [
                          (item.isInFavorite)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('message.item_in_favorite_remove')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('message.add_to_favorite')), 1))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]))
            }), 128)),
            _hoisted_33,
            _createElementVNode("span", _hoisted_34, [
              _createTextVNode(_toDisplayString(_ctx.$t('message.delivery_details')) + ":", 1),
              _hoisted_35
            ]),
            _hoisted_36,
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'div_card_mobile' : 'div_card_desktop')
            }, [
              _createVNode(_component_q_input, {
                outlined: "",
                modelValue: _ctx.nrComandaCerere,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nrComandaCerere) = $event)),
                label: _ctx.$t('message.request_no'),
                counter: "",
                maxlength: "20",
                style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width: 200px;')
              }, null, 8, ["modelValue", "label", "style"]),
              _createVNode(_component_q_input, {
                outlined: "",
                modelValue: _ctx.termenCerere,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.termenCerere) = $event)),
                mask: "##.##.####",
                label: _ctx.$t('message.delivery_term'),
                style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
                "input-style": { fontWeight: 'bolder' }
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "event",
                    class: "cursor-pointer"
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_q_popup_proxy, {
                    ref: "qDateProxy0",
                    "transition-show": "scale",
                    "transition-hide": "scale"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_date, {
                        modelValue: _ctx.termenCerere,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.termenCerere) = $event)),
                          _cache[2] || (_cache[2] = () => _ctx.$refs.qDateProxy0.hide())
                        ],
                        mask: "DD.MM.YYYY",
                        locale: _ctx.myLocale,
                        options: _ctx.optionsDataViitor
                      }, null, 8, ["modelValue", "locale", "options"])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              }, 8, ["modelValue", "label", "style"]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_q_select, {
                  outlined: "",
                  label: _ctx.$t('message.delivery_address'),
                  modelValue: _ctx.slidAdresaLivrare,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.slidAdresaLivrare) = $event)),
                  "option-value": "slid",
                  "option-label": "adresaAdresa",
                  options: _ctx.adrese,
                  "emit-value": "",
                  "map-options": "",
                  "options-selected-class": "text-deep-orange",
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
                }, {
                  option: _withCtx((scope) => [
                    _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, {
                              caption: scope.opt.isNewAddress == '1'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.opt.adresaLocalitate), 1)
                              ]),
                              _: 2
                            }, 1032, ["caption"]),
                            _createVNode(_component_q_item_label, { caption: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.opt.adresaAdresa), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 1
                }, 8, ["label", "modelValue", "options", "style"])
              ])
            ], 2),
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('message.remarks')) + " :", 1),
              _createVNode(_component_q_input, {
                maxlength: "250",
                type: "textarea",
                autogrow: "",
                counter: "",
                class: "input--desire",
                outlined: "",
                modelValue: _ctx.inputFreeTextComments,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputFreeTextComments) = $event)),
                placeholder: _ctx.$t('message.new_request_details'),
                dense: "",
                color: "blue-grey-7"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _hoisted_41,
            ( _ctx.basket.length>0)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  color: "blue",
                  label: _ctx.$t('message.send_offer_request'),
                  "no-caps": "",
                  onClick: _ctx.trySendBasketForAnOffer,
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width: 200px;float:right;')
                }, null, 8, ["label", "onClick", "style"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogAdresa,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogAdresa) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { class: "bg-white" }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      icon: "arrow_back",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 1,
                      dense: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_icon, {
                      key: 2,
                      name: "arrow_back_ios",
                      class: "app__arrow--back"
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t('message.delivery_address_details')), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t('message.delivery_address_details')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_NomEditAdresaLivrare, {
                  propAdresa: _ctx.selectedAdresa,
                  closeHandler: _ctx.closeFormEditAdresaLivrare
                }, null, 8, ["propAdresa", "closeHandler"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}